import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const FastElavtal = lazy(() => import("@/pages/elavtal/FastElavtal"));

export const Route = createFileRoute("/elavtal/fast")({
  head: () => seoHead("/elavtal/fast"),
  component: () => <FastElavtal />,
});
